import { Container, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Product.css";

const Product = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.assortsmachinetools.com/api/new-lanch-product")
      .then((res) => {
        setData(res.data.data || []);
      })
      .catch((err) => console.error(err));
  }, []);

  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          color: "rgb(18, 80, 141)",
          fontWeight: 600,
          padding: "1rem",
          fontSize: { xs: "25px", md: "30px" },
        }}
      >
        New Launches
      </Typography>

      <div style={{ background: "#181d45", padding: "2rem" }}>
        <Container>
          <Slider {...settings}>
            {data.map((item) => (
              <div key={item._id}>
                <Link to={`/our-category/category/product-name/${item._id}`}>
                  <div className="box">
                    <img
                      className="product"
                      src={
                        item.image1?.includes("cloudinary")
                          ? item.image1
                          : `https://api.assortsmachinetools.com/${item.image1}`
                      }
                      alt={item.productname}
                    />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 700,
                        padding: "8px",
                        textAlign: "center",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {item.productname}
                    </Typography>
                  </div>
                </Link>
              </div>
            ))}
          </Slider>
        </Container>
      </div>
    </>
  );
};

export default Product;
